import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../spinner/ducks';
import { apiCallIds } from '../../admin-dashboard/api';
import { fetchReportDataActions, selectReportData } from '../ducks';
import { AdminDashboard } from '../components';


const mapStateToProps = state => ({
  reportData: selectReportData(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_DASHBOARD_DATA),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchReportData: fetchReportDataActions.request,
    },
    dispatch
  )
});


@connect(mapStateToProps, mapDispatchToProps)
export default class AdminDashboardContainer extends Component {
  static propTypes = {
    actions: PropTypes.object,
  };


  constructor(props) {
    super(props);
    this.state = { reportData: {} };
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.fetchReportData()
  }


  render() {
    const { reportData, isLoading } = this.props;
    return (
      <AdminDashboard
        reportData={reportData}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/admin-dashboard/containers/AdminDashboardContainer.js